export default __webpack_public_path__ + "static/media/background-2.15b216df.jpg";